import React from 'react';
import { compose } from 'redux';
import connectActions from "shared/lib/connectActions";
import connectProps from "shared/lib/connectProps";
import actions from "fantastic/actions";

const Fail = ({ setFailMessage, app: { fail = false, fail_button = 'fail_accept', fail_reason = null } }) => {
  if(!fail || fail.length === 0) return null;
  const handleClick = () => {
    setFailMessage(null);
    if( fail_button === 'refresh' ) window.location.reload();
  }

  const pText = (text) => text.split(".").filter(t => t.length > 0).map((line, index) => <p key={index}>{line}.</p>)

  const renderText = () => {
    if(Array.isArray(fail)){
      return fail.map((t,i) => <div key={i}>{pText(t)}</div>);
    } else {
      return pText(fail);
    }
  }

  return (
    <div className="fantastic-fail">
      <div className="fantastic-fail__bg" />
      <div className="fantastic-fail__body">
        <div className="fantastic-fail__description">
          { fail_reason === 'json' ? (
            <>
              {pText(i18n.t('json_error'))}
              <p><small>{i18n.t('json_error_id')}: {fail}</small></p>
            </>
          ) : renderText() }
        </div>
        <div className="fantastic-fail__actions">
          <button className="btn btn-primary" onClick={handleClick}>{ i18n.t(fail_button) }</button>
        </div>
      </div>
    </div>
  );
};

export default compose(
  connectProps('app'),
  connectActions({
    setFailMessage: actions.setFailMessage
  })
)(Fail);

